import TableRow from "@mui/material/TableRow";
import TableCell from "../../../../BillingAndPayments/components/TableCell";
import { expanderColumnSx, metricColumnSx } from "../columnWidths";
import {
  AD,
  VALUE_NUMBER,
  VALUE_WITH_CURRENCY_MANUAL_FORMAT,
  VALUE_WITH_PERCENTAGE,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { useFormContext } from "react-hook-form";
import { renderMetricValue } from "../../../../../utils/renderMetricValue";

const MetaAdRow = ({
  indexCampaign,
  adGroupID,
  indexAd,
  adID,
  data,
  columns,
}) => {
  const { t } = useTranslationApp();
  const { campaign, getCostByMainCurrency } = useFormContext();
  const adsGroups = campaign.adsGroups || [];
  const foundAdGroup =
    adsGroups?.find((adGroup) => adGroup.id === adGroupID) || {};
  const foundAd = foundAdGroup.ads?.find((ad) => ad.id === adID) || {};

  const { cost, currency } = getCostByMainCurrency({
    cost: data.spend,
    currency: data.currency,
  });

  const { cost: costPerMainAction, currency: currencyPerMainAction } =
    getCostByMainCurrency({
      cost: data.costPerMainAction,
      currency: data.currency,
    });

  return (
    <TableRow>
      <TableCell indexRow={indexCampaign} sx={expanderColumnSx} level={3} />
      {columns.map((col) => (
        <TableCell
          key={col.key}
          indexRow={indexCampaign}
          level={3}
          sx={{ ...metricColumnSx(col.width), height: 0 }}
        >
          {(() => {
            switch (col.key) {
              case "platform":
                return foundAd?.name || `${t(AD)} ${indexAd + 1}`;
              case "spend":
                return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                  value: cost,
                  currency,
                });
              case "impressions":
                return t(VALUE_NUMBER, { value: data.impressions });
              case "reach":
                return t(VALUE_NUMBER, { value: data.reach });
              case "click":
                return t(VALUE_NUMBER, { value: data.click });
              case "ctr":
                return t(VALUE_WITH_PERCENTAGE, { value: data.ctr });
              case "mainAction":
                return t(VALUE_NUMBER, { value: data.mainAction });
              case "costPerMainAction":
                return renderMetricValue(
                  costPerMainAction,
                  col.key,
                  currencyPerMainAction
                );
              case "cpc":
                return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                  value: (data.cpc || 0).toFixed(2),
                  currency: data.currency,
                });
              case "cpm":
                return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                  value: (data.cpm || 0).toFixed(2),
                  currency: data.currency,
                });
              default:
                return renderMetricValue(data[col.key], col.key, data.currency);
            }
          })()}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default MetaAdRow;
